export default __webpack_public_path__ + "static/media/anunciantes.c079dc9d.png";